<template>
    <a href='#' class='list-action btn btn-dark active' v-if="isSaved" @click.prevent="unSave(book)">
        <i class='fa fa-star'></i>
        <span class="text-capitalize">Saved {{ trans('book.singular') }}</span>
    </a>

    <a href='#' class='list-action btn btn-dark' v-else @click.prevent="save(book)">
        <i class='fa fa-star'></i>
        <span class="text-capitalize">Save {{ trans('book.singular') }}</span>
    </a>
</template>

<script>
    export default {
        props: ['book', 'saved'],

        data: function() {
            return {
                isSaved: '',
            }
        },

        mounted() {
            this.isSaved = this.isSave ? true : false;
        },

        computed: {
            isSave() {
                return this.saved;
            },
        },

        methods: {
            save(book) {
                axios.post(this.route('book.save',{book:book}))
                    .then(response => {
                        this.isSaved = true
                        console.log(response.data);
                    })
                    .catch(response => console.log(response.data));
            },

            unSave(book) {
                axios.post(this.route('book.unsave',{book:book}))
                    .then(response => this.isSaved = false)
                    .catch(response => console.log(response.data));
            }
        }
    }
</script>